export const mutation_getInformativaPrivacyReport = `
mutation getInformativaPrivacyReport($fascicoloId : Int!, $userId : String!, $isToBeSaved : Boolean!, $isAllegato : Boolean!, $datePrint: String!) {
    getInformativaPrivacyReport(fascicoloId:$fascicoloId, userId:$userId, isToBeSaved : $isToBeSaved, isAllegato:$isAllegato, datePrint: $datePrint) {  
        response
    }
}`;
export const mutation_getAstensioneProfessionistaReport=`
mutation getAstensioneProfessionistaReport($prestazioneId: Int!,$userId: Int!, $isSelectedSos: Boolean, $selectedSosMotivo: String, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $datePrint: String!){
    getAstensioneProfessionistaReport(prestazioneId : $prestazioneId, userId : $userId, isSelectedSos: $isSelectedSos, selectedSosMotivo: $selectedSosMotivo, isToBeSaved: $isToBeSaved, isAllegato: $isAllegato, datePrint: $datePrint){
        response
    }
}`;
export const mutation_getDichiarazioneClienteReport=`
mutation getDichiarazioneClienteReport($fascicoloId: Int!,$legalReprId : Int!, $userId: Int!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $includeTerminated: Boolean!, $datePrint: String!, $includeTerminatedPrestazioni: Boolean!){
    getDichiarazioneClienteReport(fascicoloId : $fascicoloId, legalReprId: $legalReprId, userId : $userId, isToBeSaved: $isToBeSaved, isAllegato: $isAllegato, includeTerminated:$includeTerminated, datePrint: $datePrint, includeTerminatedPrestazioni: $includeTerminatedPrestazioni){
        response
    }
}`;
export const mutation_getDichiarazioneProfessionistaReport=`
mutation getDichiarazioneProfessionistaReport($fascicoloId: Int!, $nomeIdentificatore: String!, $indirizzoIdentificatore : String!, $anagraficaId: Int!, $userIdErogatore : String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $datePrint: String!, $dataIdentificatore: String){
    getDichiarazioneProfessionistaReport(fascicoloId : $fascicoloId, nomeIdentificatore: $nomeIdentificatore, indirizzoIdentificatore: $indirizzoIdentificatore , anagraficaId : $anagraficaId, userIdErogatore : $userIdErogatore, isToBeSaved: $isToBeSaved, isAllegato: $isAllegato, datePrint: $datePrint, dataIdentificatore: $dataIdentificatore){
        response
    }
}`;
export const mutation_getIstruttoriaClienteReport =`
mutation getIstruttoriaClienteReport($prestazioneIdList : String!, $userId : String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $includeTerminated: Boolean!, $datePrint: String!){
    getIstruttoriaClienteReport(prestazioneIdList : $prestazioneIdList, userId:$userId, isToBeSaved:$isToBeSaved, isAllegato:$isAllegato, includeTerminated:$includeTerminated,  datePrint: $datePrint){
        response
    }
}`;
export const mutation_getAutovalutazioneReport =`
mutation getAutovalutazioniReport($autovalutazId : Int! , $userId : String!, $tenantId: String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $datePrint: String!, $tenantTipo: Int!){
    getAutovalutazioniReport(autovalutazId : $autovalutazId, userId:$userId, tenantId:$tenantId, isToBeSaved:$isToBeSaved, isAllegato:$isAllegato, datePrint: $datePrint, tenantTipo: $tenantTipo){
        response
    }
}`;
export const mutation_getValutazioneRischioReport =`
mutation getValutazioneRischioReport($rischioId : Int!, $userId : String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $datePrint: String!){
    getValutazioneRischioReport(rischioId : $rischioId, userId:$userId, isToBeSaved:$isToBeSaved, isAllegato:$isAllegato, datePrint: $datePrint){
        response
    }
}`;
export const mutation_getIndicatoriAnomaliaReport =`
mutation getIndicatoreAnomaliaReport($indicatoreAnomaliaId : Int!, $userId : String!, $isToBeSaved: Boolean!, $isAllegato: Boolean!, $datePrint: String!){
    getIndicatoreAnomaliaReport(indicatoreAnomaliaId : $indicatoreAnomaliaId, userId:$userId, isToBeSaved:$isToBeSaved, isAllegato:$isAllegato, datePrint: $datePrint){
        response
    }
}`;